// determines how updateFilter sets the [filterKey]: structure on the filters object
export const FILTER_TYPES = {
  ATTRIBUTE: 'attribute', // used for observe resources only
  SINGLE: 'single', // used to set a simple string filter
  SELECTION: 'selection', // general default, list of checkboxes, set as [string, ...]
  KEYVALUE: 'keyvalue', // supports metadata structure, set as [{key, value}]
  DATE: 'date'
} as const
